export default "__VITE_ASSET__uRLeMdi7__"